import React, { Component } from "react";
import styles from "./logisticAlatmTool.module.scss";
import AlarmDaysPanel from "./AlarmDaysPanel";
import { getDaysWeekState } from "./LogisticDaysWeekService";
import AlarmTimePanel from "./AlarmTimePanel";
import Checkbox from "../../../shared/items/contols/checkbox";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import Preloader from "../../../shared/items/static/preloader";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

class LogisticAlatmTool extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alarm: props.alarm,
      isChance: false,
    };
  }

  onDayClickHandler(day, isCheck) {
    const { alarm } = this.state;

    if (alarm.active !== true) return;

    if (isCheck) {
      alarm.day += day;
    } else alarm.day -= day;

    this.setState({ alarm, isChance: true });
  }

  onSetTime(time, duration) {
    const { alarm } = this.state;

    alarm.time = time;
    alarm.duration = duration;

    this.setState({ alarm, isChance: true });
  }

  onSaveButtonClick() {
    const { alarm } = this.state;
    const { onUpdateAlarm } = this.props;

    onUpdateAlarm(alarm);
    this.setState({ isChance: false });
  }

  onHandleChangeStore(name, value) {
    const { alarm } = this.state;
    alarm.active = value;

    this.setState({ alarm, isChance: true });
  }

  render() {
    const { alarm, isChance } = this.state;
    const { errorTile, title = "", withDays = false, isRequest, onClose } = this.props;

    return (
      <div>
        <div className={styles.logisticAlatmToolContainer}>
          <div className={styles.closeButton} onClick={onClose}>
            <TooltipWrapper title={"Закрыть"} position="left">
              <HighlightOffIcon style={{ color: "red" }} />
            </TooltipWrapper>
          </div>

          <div className={styles.alarmTitle}> {title}</div>
          <div className={styles.firstLinePanel}>
            <AlarmTimePanel alarm={alarm} disabled={alarm.active !== true} onSetTime={this.onSetTime.bind(this)} />
            <div className={styles.logisticAlatmCheckboxContainer}>
              <div style={{ display: "flex" }}>
                <div className={styles.label}>{alarm.active !== true ? "Выкл." : "Вкл."}</div>
                <Checkbox name={"active"} valueStore={alarm} handleChange={this.onHandleChangeStore.bind(this)} />
              </div>
            </div>
          </div>

          <div className={styles.toLinePanel}>
            {withDays && alarm.day !== undefined ? (
              <div className={styles.logisticAlatmToolDaysContainer}>
                <AlarmDaysPanel dayCheked={getDaysWeekState(alarm.day)} dayClickHandler={this.onDayClickHandler.bind(this)} />
              </div>
            ) : null}
            <div className={styles.alampUpdateByttonContainer}>
              <ButtonPrimary disabled={!isChance} handleClick={this.onSaveButtonClick.bind(this)} title="Сохранить" />
            </div>
          </div>
        </div>

        {isRequest ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader />
          </div>
        ) : (
          <div className={styles.alarmUpdateErrorContainer}> {errorTile}</div>
        )}
      </div>
    );
  }
}

export default React.memo(LogisticAlatmTool);
